import { render, staticRenderFns } from "./UpdateConceptAuto.vue?vue&type=template&id=6d64ae1a&scoped=true"
import script from "./UpdateConceptAuto.vue?vue&type=script&lang=js"
export * from "./UpdateConceptAuto.vue?vue&type=script&lang=js"
import style0 from "./UpdateConceptAuto.vue?vue&type=style&index=0&id=6d64ae1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d64ae1a",
  null
  
)

export default component.exports